import { ROUTES } from '../constants/routes.constants';

/**
 * Helper function to get absolute URL for an image
 * If the image URL already starts with "http://" or "https://", return it as is
 * Otherwise, prepend the base URL (for legacy relative paths)
 * 
 * @param {string} imagePath - Image path (can be absolute URL or relative path)
 * @returns {string|null} Absolute URL or null if imagePath is empty
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath || String(imagePath).trim() === '') return null;

  const raw = String(imagePath).trim();
  const uploadsIndex = raw.indexOf('/uploads/');

  // Fichiers locaux : passer par /api/uploads pour le reverse-proxy Nginx (location /api).
  if (uploadsIndex !== -1) {
    const relativeUploads = raw.substring(uploadsIndex);
    return `${ROUTES.API_BASE_URL}${relativeUploads}`;
  }

  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    return raw;
  }

  if (raw.startsWith('/')) {
    const apiBase = ROUTES.API_BASE_URL.replace(/\/api\/?$/, '');
    return `${apiBase}${raw}`;
  }

  return raw;
};

/**
 * Helper function to get absolute URLs for an array of images
 * 
 * @param {string[]} imagePaths - Array of image paths
 * @returns {string[]} Array of absolute URLs
 */
export const getImageUrls = (imagePaths) => {
  if (!Array.isArray(imagePaths)) return [];
  return imagePaths.map(img => getImageUrl(img)).filter(img => img !== null);
};
